var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M10.5,16H7A4,4,0,0,1,7,8h3.5a.5.5,0,0,0,0-1H7A5,5,0,0,0,7,17h3.5a.5.5,0,0,0,0-1ZM8,12a.5.5,0,0,0,.5.5h7a.5.5,0,0,0,0-1h-7A.5.5,0,0,0,8,12Zm9-5H13.5a.5.5,0,0,0,0,1H17a4,4,0,0,1,0,8H13.5a.5.5,0,0,0,0,1H17A5,5,0,0,0,17,7Z",
    transform: "translate(-2 -7)",
    fill: "#424242"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinGray);
export default __webpack_public_path__ + "static/media/pin-gray.829157aa3a0c8ef22b66751588f254ae.svg";
export { ForwardRef as ReactComponent };